import { logger } from '@php-wasm/logger';
import type { CookieStore } from './php-request-handler';
/**
 * @public
 */
export class HttpCookieStore implements CookieStore {
	cookies: Record<string, string> = {};

	rememberCookiesFromResponseHeaders(headers: Record<string, string[]>) {
		if (!headers?.['set-cookie']) {
			return;
		}
		for (const setCookie of headers['set-cookie']) {
			try {
				if (!setCookie.includes('=')) {
					continue;
				}
				const equalsIndex = setCookie.indexOf('=');
				const name = setCookie.substring(0, equalsIndex);
				const value = setCookie
					.substring(equalsIndex + 1)
					.split(';')[0];
				this.cookies[name] = value;
			} catch (e) {
				logger.error(e);
			}
		}
	}

	getCookieRequestHeader() {
		const cookiesArray: string[] = [];
		for (const name in this.cookies) {
			cookiesArray.push(`${name}=${this.cookies[name]}`);
		}
		return cookiesArray.join('; ');
	}
}
